module.exports = __webpack_public_path__ + "img/timelapse_mobile_poster.1875347.jpg";